import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, Snackbar, TextField } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import React, { useEffect, useMemo, useState } from 'react';
import { ButtonCancel, ButtonContinue, FieldWrapper } from '../../../components/general/mini_components';
import PatientInfo from '../../../components/PatientInfo';
import { AgendasTypes, IAgenda, IAppointment, IDepartment } from '../../../constants/types';
import AppointmentDatePicker from './DatePicker';
import { usePrevious, useSnackBarState } from '../../../hooks';
import Typography from '@mui/material/Typography';
import Loader from '../../../components/Loader';
import { LocalizeContextProps, Translate, withLocalize } from 'react-localize-redux';


import { connect} from 'react-redux';
import { Alert } from '@mui/material';
import { isArray } from 'lodash';
import { makeAppointmentService, makeBulkAppointmentService } from '../../../services';
import { DesktopTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { errorCodesCreateAppointment, turnsAgendaDates } from '../../../utils/agenda';
import { turnsToSchedule } from '../../../utils';
import { safeLocaleCompare } from '../../../utils/sort';
import { useAgendas } from '../../../hooks/agenda';
import { ExtraAppointmentInfo } from './Appointments/NewAppointment';
import { IRequest } from '../Request/types';
import { resolveListAgendasForDepartment } from '../../../utils/appointmentPrefill';
import { useAppointmentFormPrefill } from '../../../hooks/useAppointmentFormPrefill';

interface ExtraAppointmentData {
    idService : number, 
    reason: string, 
    notes:string,
    bulkDates?: Date[],
}

interface FormAppointmentGeneralProps extends LocalizeContextProps {
    uuidPatient?: string;
    uuidInvestigation:string,
    hospital?: any,
    typeAgenda:AgendasTypes,
    mode: 'make' | 'consult',
    hidePatientInfo?: boolean,
    showAllAgendas:boolean,
    dateTimeAppointment?:boolean,
    appointment?:IAppointment | null,
    phoneNumber? : string,
    extraForm?: number,
    department?: IDepartment,
    prefillTemplate?: IAppointment | null,
    appointmentMadeCallback?: (appointment:IAppointment) => void;
    infoAppointmentReadyCallback?:(uuidAgenda:string[], date:Date) => void;
    agendaChangedCallback?:(uuidAgendas: string[]) => void;
    cancelCallback?: () => void;
}

interface FormMakeAppointmentProps {
    uuidPatient: string;
    request?: IRequest,
    uuidInvestigation:string,
    typeAgenda:AgendasTypes,
    department?: IDepartment,
    showAllAgendas:boolean,
    hidePatientInfo?: boolean,
    dateTimeAppointment:boolean,
    phoneNumber : string,
    extraForm?: number,
    prefillTemplate?: IAppointment | null,
    appointmentMadeCallback: (appointment:IAppointment) => void;
    cancelCallback: () => void;
}

interface FormConsultAppointmentProps {
    uuidInvestigation:string,
    typeAgenda:AgendasTypes,
    showAllAgendas:boolean,
    dateTimeAppointment:boolean,
    appointment:IAppointment | null,
    infoAppointmentReadyCallback:(uuidAgenda:string[], date:Date) => void;
    agendaChangedCallback?:(uuidAgendas: string[]) => void;
}

export const FormConsultAppointment: React.FC<FormConsultAppointmentProps> = ({ uuidInvestigation, showAllAgendas, appointment, dateTimeAppointment, typeAgenda,
                                                                                    infoAppointmentReadyCallback, agendaChangedCallback }) => {
    
    return <FormAppointmentGeneralConnected uuidInvestigation={uuidInvestigation} mode='consult' showAllAgendas={showAllAgendas}
                dateTimeAppointment={dateTimeAppointment} typeAgenda={typeAgenda}
                appointment={appointment}
                infoAppointmentReadyCallback={infoAppointmentReadyCallback} 
                agendaChangedCallback={agendaChangedCallback} />
};

export const FormMakeAppointment: React.FC<FormMakeAppointmentProps> = ({ uuidPatient, showAllAgendas, department, dateTimeAppointment, typeAgenda, request,
                                                                            extraForm, uuidInvestigation, hidePatientInfo, phoneNumber, prefillTemplate,
                                                                            appointmentMadeCallback, cancelCallback }) => {
    
    return <FormAppointmentGeneralConnected showAllAgendas={showAllAgendas} uuidInvestigation={uuidInvestigation} uuidPatient={uuidPatient} mode='make'
                hidePatientInfo={hidePatientInfo} department={department} dateTimeAppointment={dateTimeAppointment} phoneNumber={phoneNumber}
                typeAgenda={typeAgenda}
                extraForm={extraForm} request={request} prefillTemplate={prefillTemplate}
                appointmentMadeCallback={appointmentMadeCallback} cancelCallback={cancelCallback} />
};

const FormAppointmentGeneral: React.FC<FormAppointmentGeneralProps> = ({ uuidInvestigation, department, uuidPatient, mode, hospital, hidePatientInfo, showAllAgendas, 
                                                                            dateTimeAppointment, phoneNumber, extraForm, typeAgenda, appointment, request, prefillTemplate,
                                                                            appointmentMadeCallback, infoAppointmentReadyCallback, agendaChangedCallback,
                                                                            cancelCallback, translate }) => {
    const {agendas, loadingAgendas} = useAgendas(typeAgenda);
    //const appointments =  useSelector((state:any) => state.hospital.data.appointments);
    const [appointments, setAppointments] = useState<IAppointment[] | null>(null);
    const [departmentsWithAgenda, setDepartmentsWithAgenda] = useState<IDepartment[]>([]);
    const prevAppointments:IAppointment[] | null = usePrevious(hospital.data.appointments);
    const [appointmentCreated, setAppointmentCreated] = useState<boolean | IAppointment>(false);
    const [error, setError] = useState<number>(-1);
    const [loading, setLoading] = useState<boolean>(false);
    const [bulkSuccessCount, setBulkSuccessCount] = useState<number>(0);

    function makeBulkAppointments(uuidAgenda:string, dates:Date[], makeAppointmentData: ExtraAppointmentData){
        setLoading(true);
        setError(-1);
        setBulkSuccessCount(0);
        makeBulkAppointmentService(uuidInvestigation, uuidAgenda, uuidPatient, dates, makeAppointmentData.idService, phoneNumber, makeAppointmentData.reason, makeAppointmentData.notes)
            .then((response) => {
                const createdAppointments = response.appointments ?? [];
                const tempAppointments = appointments ? [...appointments] : [];
                tempAppointments.push(...createdAppointments);
                setAppointments(tempAppointments);
                setBulkSuccessCount(createdAppointments.length);
                setAppointmentCreated(createdAppointments[createdAppointments.length - 1] ?? true);
                setLoading(false);
            })
            .catch((error) => {
                setAppointmentCreated(false);
                setError(error.errorCode ?? -1);
                setLoading(false);
            });
    }

    function makeAppointment(uuidAgenda:string, date:Date, makeAppointmentData: ExtraAppointmentData){
        setLoading(true);
        setError(-1);
        makeAppointmentService(uuidInvestigation, typeAgenda, uuidAgenda, uuidPatient, date, makeAppointmentData.idService, phoneNumber, makeAppointmentData.reason, makeAppointmentData.notes)  
            .then((response) => {
                const tempAppointments = appointments ? [...appointments] : [];
                tempAppointments.push(response.appointment);
                setAppointments(tempAppointments);
                setAppointmentCreated(response.appointment);
                setLoading(false);
            })
            .catch((error) => { 
                setAppointmentCreated(false);
                setError(error.errorCode);
                setLoading(false);
            });
    }

    function infoAppointmentReady(uuidAgendas:string[], date:Date, makeAppointmentData?: ExtraAppointmentData){
        if(appointmentMadeCallback){
            if(makeAppointmentData?.bulkDates?.length){
                makeBulkAppointments(uuidAgendas[0], makeAppointmentData.bulkDates, makeAppointmentData);
            }
            else {
                makeAppointment(uuidAgendas[0], date, makeAppointmentData as ExtraAppointmentData);
            }
        }
        else if(infoAppointmentReadyCallback){
            infoAppointmentReadyCallback(uuidAgendas, date);
        }
    }

    useEffect(() => {
        if(agendas){
            const departmentsDict:{[uuidDepartment:string]:IDepartment} = {};
            agendas.forEach((agenda) => {
                if(agenda.department){
                    const uuidDepartment = agenda.department.uuid as string;
                    departmentsDict[uuidDepartment] = agenda.department;
                }
            });
            if(department){
                if(departmentsDict[department.uuid as string]){
                    setDepartmentsWithAgenda([department]);
                }
            }
            else{
                const departmentsWithAgenda:IDepartment[] = Object.values(departmentsDict);
                setDepartmentsWithAgenda(departmentsWithAgenda);
            }
        }
        
    }, [agendas]);

    useEffect(() => {
        
        if((!prevAppointments && isArray(appointments) && appointmentCreated && appointmentMadeCallback) || 
            (isArray(prevAppointments) && isArray(appointments) && prevAppointments.length < appointments.length && appointmentMadeCallback)){
            
            setTimeout(() => {
                appointmentMadeCallback(appointmentCreated as IAppointment);
            }, 2000);   
        }
    }, [appointments, appointmentCreated]);

    

    if(loadingAgendas || hospital.loading){
        return <Loader />
    }
    else if(agendas !== null){
        return (
            <>
                <FormAppointmentCore uuidPatient={uuidPatient} departmentsWithAgenda={departmentsWithAgenda} 
                    error={error } mode={mode} showAllAgendas={showAllAgendas} dateTimeAppointment={Boolean(dateTimeAppointment)}
                    loading={loading} hidePatientInfo={hidePatientInfo}
                    appointment={appointment} prefillTemplate={prefillTemplate} typeAgenda={typeAgenda} request={request}
                    appointmentCreated={Boolean(appointmentCreated)} extraForm={extraForm}
                    bulkSuccessCount={bulkSuccessCount}
                    agendas={agendas} infoAppointmentCallback={infoAppointmentReady}
                    agendaChangedCallback={agendaChangedCallback}
                    cancelCallback={cancelCallback}
                    translate={translate} />
            </>
        );
    }
    else{
        return <Typography>There are no agendas</Typography>
    }
    
};

const mapStateToProps = (state:any) =>{
    return {
        hospital:state.hospital, 
        investigations:state.investigations
    }
}

const FormAppointmentGeneralConnected = withLocalize(connect(mapStateToProps, null)(FormAppointmentGeneral));

interface FormAppointmentCoreProps extends LocalizeContextProps, Omit<FormAppointmentGeneralProps, 'makeAppointmentAction' | 'appointmentMadeCallback' | 'uuidInvestigation' | 'hospital'> {
    departmentsWithAgenda:IDepartment[];
    agendas:IAgenda[];
    error:number;
    request?: IRequest;
    typeAgenda:AgendasTypes;
    showAllAgendas:boolean;
    dateTimeAppointment:boolean;
    hidePatientInfo?:boolean,
    loading:boolean;
    extraForm?:number;
    appointmentCreated:boolean;
    bulkSuccessCount?: number;
    infoAppointmentCallback: (uuidAgendas: string[], date: Date, makeAppointmentData?: ExtraAppointmentData) => void;
    cancelCallback: () => void;
}

export const FormAppointmentCore: React.FC<FormAppointmentCoreProps> = ({ uuidPatient, loading, showAllAgendas, dateTimeAppointment, extraForm,
                                                                            appointment, prefillTemplate, typeAgenda, request, translate,
                                                                            departmentsWithAgenda, hidePatientInfo, agendas, mode, error, appointmentCreated, bulkSuccessCount,
                                                                            infoAppointmentCallback, agendaChangedCallback, cancelCallback }) => {
    const [department, setDepartment] = useState<IDepartment | null>(null);
    const [errorState, setErrorState] = useState<{department:boolean, agenda:boolean, service:boolean, date:boolean}>({department:false, agenda:false, date:false, service:false});
    const [showSnackbar, setShowSnackbar, handleCloseSnackbar] = useSnackBarState();
    const [agendasSelected, setAgendasSelected] = useState<IAgenda[]>([]);
    const now = new Date();
    now.setHours(0,0,0,0);
    const [timeSelected, setTimeSelected] = useState<Date>(now);
    const [date, setDate] = useState<Date | null>(null);
    const [selectedDates, setSelectedDates] = useState<Date[]>([]);
    const [showBulkConfirm, setShowBulkConfirm] = useState<boolean>(false);
    const [pendingBulkSubmission, setPendingBulkSubmission] = useState<{ uuidAgendas: string[], dates: Date[], makeAppointmentData: ExtraAppointmentData } | null>(null);
    const enableBulkAppointmentCreation = mode === 'make' && typeAgenda === AgendasTypes.CONSULTATION && !dateTimeAppointment;
    const [service, setService] = useState<{id:number} | null>(null);
    const [reason, setReason] = useState<string>("");
    const [notes, setNotes] = useState<string>("");
    const [agendaSelected, setAgendaSelected] = useState<IAgenda | null>(null);
    const { prefillWarnings, prefillBootstrap } = useAppointmentFormPrefill(
        prefillTemplate,
        agendas,
        departmentsWithAgenda,
        mode,
    );
    const listAgendas = useMemo(
        () => resolveListAgendasForDepartment(agendas, departmentsWithAgenda, department, showAllAgendas),
        [agendas, departmentsWithAgenda, department, showAllAgendas],
    );

    const prefillWarningMessage = useMemo(() => {
        if (prefillWarnings.length === 0) {
            return null;
        }
        if (prefillWarnings.includes('agenda_unavailable')) {
            return 'pages.hospital.outpatients.form_appointment.prefill_agenda_unavailable';
        }
        if (prefillWarnings.includes('service_unavailable')) {
            return 'pages.hospital.outpatients.form_appointment.prefill_service_unavailable';
        }
        return null;
    }, [prefillWarnings]);

    useEffect(() => {
        if(agendasSelected.length > 1){
            const daysWeek = agendasSelected.flatMap(agenda => agenda.daysWeek);
            const slotsPerDay = agendasSelected.reduce((acc, agenda) => acc + agenda.slotsPerDay, 0);
            const blockedDates = agendasSelected.flatMap(agenda => agenda.blockedDates);
            const newAgenda = {...agendasSelected[0], daysWeek, slotsPerDay, blockedDates};
            setAgendaSelected(newAgenda);
        }
        else{
            setAgendaSelected(agendasSelected.length === 1 ? agendasSelected[0] : null);
        }
        
    }, [agendasSelected]);
    
    useEffect(() => {
        if(agendaSelected && !service && agendaSelected.listServicesInvestigation.length === 1){
            setService(agendaSelected.listServicesInvestigation[0]);
        }
    }, [agendasSelected]);

    useEffect(() => {
        if (agendaChangedCallback) {
            agendaChangedCallback(agendasSelected.map((agenda) => agenda.uuid));
        }
    }, [agendaSelected])

    function renderDepartments(){
        if(departmentsWithAgenda.length === 0){
            return  null;
        }
        if(mode !== 'make' && departmentsWithAgenda.length === 1){
            return (
                <>
                    <Typography variant="body2">Department: </Typography>{departmentsWithAgenda[0].name}
                </>)
        }
        const optionsArray = departmentsWithAgenda.sort((a, b) => safeLocaleCompare(a.name, b.name)).map((department) => {
            return <MenuItem key={department.uuid} value={department.uuid}>{department.name}</MenuItem>
        })
        return (
            <FieldWrapper noWrap>
                <FormControl fullWidth variant="outlined" margin="dense" error={errorState.department} >
                    <InputLabel id="department">{translate("pages.hospital.outpatients.agenda.select_department")}</InputLabel>
                    <Select
                        labelId="department"
                        id="department"
                        value={department?.uuid || ''}
                        label={translate("pages.hospital.outpatients.agenda.select_department")}
                        onChange={(event) => {
                            const uuidDepartment = event.target.value as string;
                            const nextDepartment = departmentsWithAgenda.find((dept) => dept.uuid === uuidDepartment);
                            if(nextDepartment){
                                setDepartment(nextDepartment);
                                setAgendasSelected([]);
                                setAgendaSelected(null);
                                setDate(null);
                                setSelectedDates([]);
                                setService(null);
                            }
                        }}
                    >
                    { optionsArray }
                    </Select>
                </FormControl>
            </FieldWrapper>
        )
    }

    function updateDateTime(dateSelected:Date, time:Date){
        if(dateTimeAppointment){
            // Combine date and time
            const combined = new Date(dateSelected);
            combined.setHours(time.getHours(), time.getMinutes());
            dateSelected = combined;
        }
        setDate(dateSelected);
    }
    function onDatesChange(datesSelected:Date[]){
        setSelectedDates(datesSelected);
        if(datesSelected.length > 0){
            setDate(datesSelected[datesSelected.length - 1]);
        }
    }
    function onDateChange(dateSelected:Date, time:Date){
        if(dateSelected !== null){
            updateDateTime(dateSelected, time);
            if(mode === 'consult'){
                const uuidsAgendas = agendasSelected ? agendasSelected.map((agenda) => agenda.uuid) : [];
                infoAppointmentCallback(uuidsAgendas, dateSelected);
            }
        }
    }

    function renderCalendar(){
        if(((service || typeAgenda === AgendasTypes.SURGERY) && mode === 'make' && agendaSelected) || (agendaSelected && mode === 'consult')){
            
            const timePicker = <FormControl fullWidth variant="outlined" margin="dense"  >
                                    <FieldWrapper noWrap ={null}>
                                    <DesktopTimePicker
                                        label={<Translate id="pages.hospital.outpatients.agenda.select_time" />}
                                        value={dayjs(timeSelected)}
                                        ampm={false}
                                        // shouldDisableTime={(timeValue, clockType) => {
                                        //     if(clockType === 'hours'){
                                        //         return timeValue.hour() < turnsDates[0].getHours() || timeValue.hour() > turnsDates[1].getHours();    
                                        //     }
                                        //     //return timeValue.minute() < turnsDates[0].getMinutes() || timeValue.minute() > turnsDates[1].getMinutes();
                                            
                                        // }}
                                        onChange={(newValue) => {
                                            updateDateTime(date, newValue.toDate())}}
                                    />
                                    <Typography variant="body2">
                                        <Translate id="pages.hospital.outpatients.agenda.schedule" />:&nbsp;
                                        {turnsToSchedule(agendaSelected!.turn)}
                                    </Typography>
                                </FieldWrapper>
                                </FormControl>
            return (
                <Grid container>
                    { dateTimeAppointment && mode === 'make' &&
                        <Grid item xs={12}>     
                            { timePicker }
                        </Grid>
                    }
                    <Grid item xs={12} md={enableBulkAppointmentCreation ? 6 : 12}>
                        <FormControl fullWidth variant="outlined" margin="dense"  >
                            <AppointmentDatePicker 
                                availableDaysWeek = {agendaSelected!.daysWeek} 
                                blockedDates={agendaSelected!.blockedDates} 
                                autoCurrentDate={!enableBulkAppointmentCreation}
                                multiSelect={enableBulkAppointmentCreation}
                                slotsPerDay={agendaSelected!.slotsPerDay} 
                                initialDate={appointment?.startDateTime}
                                datesOccupancy={agendaSelected!.datesOccupancy}
                                onDatesChangeCallback={onDatesChange}
                                onDateChangeCallback={(dateSel:Date) => {
                                    onDateChange(dateSel, timeSelected);
                                }} 
                            />
                            
                        </FormControl>
                    </Grid>
                    {
                        renderExtraInfo()
                    }
                </Grid>
            )
        }
    }

    function renderExtraInfo(){
        if((service && mode !== 'consult' )){
            return (
                <ExtraAppointmentInfo
                    extraForm={extraForm}
                    reason={reason}
                    setReason={setReason}
                    notes={notes}
                    setNotes={setNotes}
                />
              );
        }
        
    }
    function renderServices(){
        if(!agendaSelected || mode === 'consult' || typeAgenda === AgendasTypes.SURGERY){
            return null;
        }
        if(agendaSelected!.listServicesInvestigation.length === 0){
            return <Typography variant="body2"><Translate id="pages.hospital.outpatients.form_appointment.no-services" /></Typography>
        }
        const optionsArray = agendaSelected!.listServicesInvestigation.sort((a, b) => a.description.localeCompare(b.description)).map((service) => {
            return (
                <MenuItem value={service.id}>{service.description}</MenuItem>
            )
        });
        
        return (
            <FieldWrapper noWrap>
                <FormControl fullWidth variant="outlined" margin="dense" error={errorState.agenda} >
                    <InputLabel id="service"><Translate id="pages.hospital.outpatients.form_appointment.service" /></InputLabel>
                    <Select disabled={department === null && departmentsWithAgenda.length > 0}
                        labelId="service"
                        id="service"
                        value={service?.id ?? ''}
                        label="Select service"
                        onChange={(event) => {
                            const idService = event.target.value as string;
                            const service = agendaSelected!.listServicesInvestigation.find((service) => service.id === idService);
                            if(service){
                                setService(service);
                            }
                        }}
                    >
                    { optionsArray }
                    </Select>
                </FormControl>
            </FieldWrapper>
        );
    }
    function renderAgendas(){
        if(listAgendas.length === 0){
            return null;
        }
        if(mode !== 'make' && listAgendas.length === 1){
            return(
                <>
                    <Typography variant="body2"><Translate id="pages.hospital.outpatients.form_appointment.agenda" />: </Typography>{listAgendas[0].name}
                </>
            );
        }
        let optionsArray = listAgendas.sort((a, b) => safeLocaleCompare(a.name, b.name)).map((agenda) => {
            return (
                <MenuItem key={agenda.uuid} value={agenda.uuid}>{agenda.name}</MenuItem>
            )
        });
        if(dateTimeAppointment && mode ==='consult'){
            optionsArray.unshift(<MenuItem key="all" value="all"><Translate id="pages.hospital.outpatients.form_appointment.select_all_agendas" /></MenuItem>);
        }
        return (
            <FieldWrapper noWrap>
                <FormControl fullWidth variant="outlined" margin="dense" error={errorState.agenda} >
                    <InputLabel id="agenda"><Translate id="pages.hospital.outpatients.form_appointment.select_agenda" /></InputLabel>
                    <Select disabled={department === null && departmentsWithAgenda.length > 0}
                        labelId="agendas"
                        id="agendas"
                        label={translate("pages.hospital.outpatients.form_appointment.select_agenda")}
                        value={agendasSelected.length === 1 ? agendasSelected[0].uuid : ''}
                        onChange={(event) => {
                            const uuidAgenda = event.target.value as string;
                            if(dateTimeAppointment && uuidAgenda === "all"){
                                setAgendasSelected(listAgendas);
                                setDate(null);
                                setService(null);
                                return;
                            }
                            const agenda = listAgendas.find((candidate) => candidate.uuid === uuidAgenda);
                            if(agenda){
                                setAgendasSelected([agenda]);
                                setDate(null);
                                setSelectedDates([]);
                                setService(null);
                            }
                        }}
                    >
                    { optionsArray }
                    </Select>
                </FormControl>
            </FieldWrapper>
        );
    }

    function confirm(){
        const nextErrorState = { ...errorState };
        let hasError = false;

        if(department === null && departmentsWithAgenda.length > 0){
            nextErrorState.department = true;
            hasError = true;
        }
        if(!agendaSelected){
            nextErrorState.agenda = true;
            hasError = true;
        }
        if(!service){
            nextErrorState.service = true;
            hasError = true;
        }
        if(!date && selectedDates.length === 0){
            nextErrorState.date = true;
            hasError = true;
        }
        if(hasError){
            setErrorState(nextErrorState);
            return;
        }

        const uuidAgendas = agendasSelected.map((agenda) => agenda.uuid);
        let makeAppointmentData: ExtraAppointmentData | undefined;
        if(typeAgenda === AgendasTypes.CONSULTATION){
            makeAppointmentData = {idService: service!.id, reason, notes: notes};
        }
        else if(typeAgenda === AgendasTypes.SURGERY && request){
            makeAppointmentData = {idService: request.id, reason, notes: notes};
        }
        if(!makeAppointmentData){
            return;
        }
        if(enableBulkAppointmentCreation && selectedDates.length > 1){
            setPendingBulkSubmission({ uuidAgendas, dates: selectedDates, makeAppointmentData });
            setShowBulkConfirm(true);
            return;
        }
        infoAppointmentCallback(uuidAgendas, date!, makeAppointmentData);
    }

    function confirmBulkCreation(){
        if(!pendingBulkSubmission){
            return;
        }
        const { uuidAgendas, dates, makeAppointmentData } = pendingBulkSubmission;
        setShowBulkConfirm(false);
        setPendingBulkSubmission(null);
        infoAppointmentCallback(uuidAgendas, dates[dates.length - 1], { ...makeAppointmentData, bulkDates: dates });
    }

    useEffect(() => {
        if(error !== -1){
            setShowSnackbar({show:true, message:errorCodesCreateAppointment(error), severity:"error"});
        }
        else if(appointmentCreated){
            const successMessage = bulkSuccessCount && bulkSuccessCount > 1
                ? translate("pages.hospital.outpatients.bulk_success").replace('%count%', String(bulkSuccessCount))
                : `pages.hospital.outpatients.appointment.success`;
            setShowSnackbar({show:true, message: successMessage, severity:"success"});            
        }
        
    }, [error, appointmentCreated]);

    useEffect(() => {
        if(listAgendas.length === 1){
            setAgendasSelected(listAgendas);
        }
    }, [listAgendas])

    useEffect(() => {
        if (appointment && listAgendas.length > 0) {
            const appointmentAgenda = listAgendas.find(agenda => agenda.uuid === appointment.agenda.uuid);
            if (appointmentAgenda) {
                setAgendasSelected([appointmentAgenda]);
                setAgendaSelected(appointmentAgenda);
                // Set the date from the appointment
                const appointmentDate = new Date(appointment.startDateTime);
                setDate(appointmentDate);
                setTimeSelected(appointmentDate);
            }
        }
    }, [appointment, listAgendas]);

    useEffect(() => {
        if (!prefillBootstrap) {
            return;
        }
        if (prefillBootstrap.department) {
            setDepartment(prefillBootstrap.department);
        }
        if (prefillBootstrap.agenda) {
            setAgendasSelected([prefillBootstrap.agenda]);
            setAgendaSelected(prefillBootstrap.agenda);
        }
        if (prefillBootstrap.service) {
            setService(prefillBootstrap.service);
        }
    }, [prefillBootstrap]);

    useEffect(() => {
        if(departmentsWithAgenda.length === 1){
            setDepartment(departmentsWithAgenda[0]);
        }
    }, [departmentsWithAgenda])

    useEffect(() => {
        // When viewing an appointment with multiple departments, 
        // automatically select the department that the appointment's agenda belongs to
        if (appointment && appointment.agenda.uuidDepartment && departmentsWithAgenda.length > 1) {
            const appointmentDepartment = departmentsWithAgenda.find(
                dept => dept.uuid === appointment.agenda.uuidDepartment
            );
            if (appointmentDepartment && !department) {
                setDepartment(appointmentDepartment);
            }
        }
    }, [appointment, departmentsWithAgenda])

    function renderButtons(){
        if(mode === "make" && !loading && !appointmentCreated && (department && departmentsWithAgenda.length > 0) || (!department && departmentsWithAgenda.length === 0)){
            return (
                <Grid item xs={12} style={{paddingTop:'1rem'}}>
                    <ButtonCancel onClick={cancelCallback} data-testid="cancel-modal"  spaceright={1}>
                        <Translate id="general.cancel" />
                    </ButtonCancel>
                    &nbsp;
                    <ButtonContinue onClick={confirm} data-testid="continue-modal"  >
                        <Translate id="general.continue" />
                    </ButtonContinue>
                </Grid>
            )
        }
        else if(mode === "make" && loading){
            return (
            <Grid item xs={12} style={{paddingTop:'1rem'}}>
                    <Loader />
            </Grid>);
        }
        
    }
    
    return (
        <>
            <Dialog open={showBulkConfirm} onClose={() => setShowBulkConfirm(false)}>
                <DialogTitle><Translate id="general.confirm" /></DialogTitle>
                <DialogContent>
                    {pendingBulkSubmission &&
                        translate("pages.hospital.outpatients.bulk_confirm_message").replace('%count%', String(pendingBulkSubmission.dates.length))
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowBulkConfirm(false)}><Translate id="general.cancel" /></Button>
                    <Button onClick={confirmBulkCreation} variant="contained"><Translate id="general.continue" /></Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
                }}
                open={showSnackbar.show}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}>
                   <Alert onClose={() => setShowSnackbar({show:false})} severity={showSnackbar.severity}>
                        {showSnackbar.message?.includes('pages.')
                            ? <Translate id={showSnackbar.message} />
                            : showSnackbar.message}
                    </Alert>
                    
                </Snackbar>

                <Grid container spacing={1}>
                    { (uuidPatient && !hidePatientInfo) &&
                        <Grid item xs={12}>
                            <PatientInfo uuidPatient={uuidPatient} />
                        </Grid>
                    }
                    {prefillWarningMessage &&
                        <Grid item xs={12}>
                            <Alert severity="info" data-testid="appointment-prefill-warning">
                                <Translate id={prefillWarningMessage} />
                            </Alert>
                        </Grid>
                    }
                    
                    <Grid item xs={12}>
                    {
                        renderDepartments()
                    }
                    </Grid>
                    <Grid item xs={12}>
                    {
                        renderAgendas()
                    }
                    </Grid>
                    <Grid item xs={12}>
                    {
                        renderServices()
                    }
                    </Grid>
                    <Grid item xs={12}>
                    {
                        renderCalendar()
                    }
                    </Grid>
                    
                    {
                        renderButtons()
                    }
                   
                </Grid>
        </>
        
    );
};

export default FormAppointmentGeneralConnected;